export const TOM_REPORT_TYPES = {
    successfully_set_up: '0',
    restarted: '1',
    set_off: '2',
    rearmed: '3',
    heartbeat_missed: '4',
    offline: '5',
    locating_now: '6',
    locating_fail: '7',
    settings_updated: '8',
    update_installed: '9',
    battery_low: '10',
    online_now: '11',
    inactive_now: '12',
    unstable_connection: '13',
    infested: '14',
    light_infestation: '15',
    severe_infestation: '16',
    false_trigger: '17',
    activity_warning: '18',
    activity_critical: '19'
}

export const TOM_CRITICAL_REPORT_TYPES = {
    2: 'set_off',
    5: 'offline',
    14: 'infested',
    16: 'severe_infestation',
    19: 'activity_critical'
}

export const TOM_WARNING_REPORT_TYPES = {
    4: 'heartbeat_missed',
    13: 'unstable_connection',
    15: 'light_infestation',
    17: 'false_trigger',
    18: 'activity_warning'
}

export const TOM_CONTENT_TYPES = {
    unknown: 'unknown',
    empty: 'empty',
    mouse: 'mouse',
    rat: 'rat',
    bedbug: 'bedbug',
    ant: 'ant',
    cockroach: 'cockroach',
    roach: 'roach',
    moth: 'moth',
    fly: 'fly',
    other: 'other'
}